import { AppIcon } from '@backrs_ui/common-ui';

import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';
import type {
  ApplicationPlan,
  UserCollege,
} from '@backrs_ui/grow-ui/src/redux/userColleges/userColleges.types';

import { Box, SxProps, Theme, Typography } from '@mui/material';

import { OptionChip } from './OptionChip';
import { offeredPlans } from '../myColleges.util';

const STRINGS = appStrings.modules.myColleges;

type PlanPickerProps = Readonly<{
  id: string;
  college: UserCollege;
  onChange: (plan: ApplicationPlan) => void;
}>;

export const PlanPicker = ({ id, college, onChange }: PlanPickerProps) => (
  <OptionChip<ApplicationPlan | ''>
    id={id}
    value={college.application_plan ?? ''}
    options={offeredPlans(college).map((plan) => ({
      value: plan,
      label: STRINGS.planLabels[plan],
    }))}
    onChange={(plan) => plan && onChange(plan)}
    triggerSx={triggerSx}
    trigger={
      <>
        <Typography
          variant={college.application_plan ? 'text-sm-regular' : 'text-sm-semibold'}
          sx={college.application_plan ? planValueSx : choosePlanSx}
        >
          {college.application_plan ? STRINGS.planLabels[college.application_plan] : STRINGS.noPlan}
        </Typography>
        <Box className="plan-edit-icon" sx={editIconSx}>
          <AppIcon iconName="Edit02" diameter="14px" color="Gray/400" />
        </Box>
      </>
    }
  />
);

const triggerSx: SxProps<Theme> = ({ backrs }) => ({
  alignItems: 'center',
  gap: backrs.spacing['spacing-xs'],
  '&:hover .plan-edit-icon': { opacity: 1 },
});

const editIconSx: SxProps<Theme> = {
  display: 'flex',
  opacity: 0,
  transition: 'opacity 0.15s',
  '@media (hover: none)': { opacity: 1 },
};

const planValueSx: SxProps<Theme> = ({ backrs }) => ({
  color: backrs.colors['Colors/Text/text-tertiary'],
});

const choosePlanSx: SxProps<Theme> = ({ backrs }) => ({
  color: backrs.colors['Colors/Text/text-brand-secondary'],
});
